import { Page } from '../../../core/entities/page/page';
import { gql } from 'apollo-angular';
import { Task } from 'src/app/rent-module/shared/entities/task/task';

export const MY_TASKS_LIST_QUERY = gql`
query GetMyTasksListQuery(
  $sortProperty: String,
  $sortDirection: String,
  $text: String,
  $fromDueDateTime: String,
  $toDueDateTime: String,
  $includeOverDue: Boolean,
  $locationIds: [UUID]
  $pageNumber: Int, $pageSize: Int,
  $types: [String]
)
{
  myTasks: getTasksPaged(
    taskFilter: {
      states: [ASSIGNED],
      assignedToCurrentUser: true,
      locationIds: $locationIds 
      text: $text,
      types: $types,
      fromDueDateTime: $fromDueDateTime,
      toDueDateTime: $toDueDateTime,
      includeOverDue: $includeOverDue,
      sortRequest: { 
        sortProperties: [$sortProperty],
        sortDirection: $sortDirection
      },
      pagination: {
        number: $pageNumber,
        size: $pageSize,
        sortProperty: $sortProperty,
        sortDirection: $sortDirection
      },
    }
  ){
    totalPages
    totalElements
    number
    size
    content{
      ... myTaskExcerpt
    }
  }
}

fragment myTaskExcerpt on Task{
  id
  type
  number
  taskType {
    code
    name
    prefix
    icon
    color
  }
  dueDateTimePeriod {
    modifier
    dateTime
    fromDateTime
    toDateTime
    precision
  }
  state
  title
  fileCount
  commentCount
  createdBy {
    id
    firstName
    lastName
  }
  createdDateTime
  completedDateTime
  lastModifiedDateTime
  assignment {
    assigneeId
    assignmentType
    typeLabel
    name
  }
  linkedOrders: linkedEntities(entityType: "Order") {
    linkId
    linkedEntity {
      ... on Order {
        id
        number
        note
      }
    }
  }
  linkedResources: linkedEntities(entityType: "Resource") {
    linkId
    linkedEntity {
      ... on Resource {
        id
        text
      }
    }
  }
  linkedContacts: linkedEntities(entityType: "Contact") {
    linkId
    linkedEntity {
      ... on Contact {
        id
        text
      }
    }
  }
  address {
    id
    country
    city
    postalCode
    street
    houseNumber
    name
    lat
    lng
    text
    type
    note
    geocodingResultGrade
    ref
  }
  location {
    name
  }
}
`;

export interface MyTasksListQueryResponse {
  myTasks: Page<Task>;
}


